const apiUrl = process.env.REACT_APP_API_URL;

export const GetJutgePracticaIdUsuariIdAnalyze = async (idPrac: string, idUser: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/practica/${idPrac}/usuaris/${idUser}/analyze`);
        if (response.ok) {
            return await response.json();
        }
        return null;
    } catch (e) {
        return null;
    }
};
